import { defineStore } from 'pinia'
import { jwtDecode } from 'jwt-decode'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    jwt: null,
    authInitialized: false,
    _authReadyPromise: null,
    _authReadyResolve: null,
  }),

  getters: {
    isLoggedIn: (state) => {
      return !!state.jwt
    },
    headers: (state) => {
      return {
        Authorization: `Bearer ${state.jwt}`,
      }
    },
    hasRole: (state) => (role) => {
      return state.user?.role === role
    },
  },

  actions: {
    _ensureAuthReadyPromise() {
      if (!this._authReadyPromise) {
        this._authReadyPromise = new Promise((resolve) => {
          this._authReadyResolve = resolve
        })
      }
    },

    _markAuthReady() {
      this.authInitialized = true
      if (this._authReadyResolve) {
        this._authReadyResolve()
        this._authReadyResolve = null
      }
    },

    setJWT(token) {
      this.jwt = token

      if (token) {
        localStorage.setItem('jwt', token)
      } else {
        localStorage.removeItem('jwt')
      }
    },

    setUser(user) {
      this.user = user
    },

    setUserFromJWT(token) {
      try {
        const payload = jwtDecode(token)
        this.user = {
          username: payload.username,
          role: payload.role,
          language: payload.language || 'fr',
        }
      } catch (error) {
        // Error decoding JWT
      }
    },

    login(token) {
      this.setJWT(token)
      this.setUserFromJWT(token)
      this._markAuthReady()
    },

    logout() {
      this.setJWT(null)
      this.setUser(null)
    },

    initializeAuth() {
      const token = localStorage.getItem('jwt')
      if (token) {
        this.setJWT(token)
        this.setUserFromJWT(token)
      }
      this._markAuthReady()
    },

    async waitForAuthReady() {
      if (this.authInitialized) {
        return
      }

      this._ensureAuthReadyPromise()
      this.initializeAuth()
      await this._authReadyPromise
    },
  },
})
